<template>
    <div class="main-activity">
        <div class="activity-content">
            <div class="activity-menus">
                <ul>
                    <li :class="activeName == 1?'active':''" @click="handleClick(1)">版权活动通知</li>
                    <li :class="activeName == 2?'active':''" @click="handleClick(2)">版权活动报道</li>
                </ul>
            </div>
            <div class="activity-list">
                <div class="activity-item" v-for="item in activeReport" @click="activityDetails(item)">
                    <div class="activity-img">
                        <img v-if="item.thumbnailId" width="100%" height="100%" :src="'resrun-paas/file/downloadFileStream/'+item.thumbnailId" :alt="item.activityName" >
                    </div>
                    <div class="activity-right">
                        <div class="activity-title">
                            <p class="title" :title="item.activityName">{{item.activityName}}</p>
                            <p class="date">{{item.updateTime}}</p>
                        </div>
                        <div class="desc">
                            {{item.tenantName}}-{{ getActivityType(item.tenantType) }}
                        </div>
                        <div class="activity-icon">
                            <svg width="32" height="32" viewBox="0 0 32 32"  xmlns="http://www.w3.org/2000/svg">
                                <path d="M26.6667 15.867H4V17.2003H26.9333L22.4 21.7337L23.3333 22.667L29.3333 16.667L23.3333 10.667L22.4 11.6003L26.6667 15.867Z"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="pagination" v-if="pageInfo.total > pageInfo.pageSize">
                    <div>
                        <el-button size="small" icon="el-icon-arrow-left" @click="prePage()" :disabled="pageInfo.current == 1">上一页</el-button>
                    </div>
                    <div>
                        <el-button size="small" :disabled="pageInfo.pages  == pageInfo.current" @click="nextPage()">下一页<i class="el-icon-arrow-right el-icon--right" ></i></el-button>
                    </div> 
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { getCopyrightActive } from '@/api/business'
    import {getActivityType} from "./state"
    export default {
        name:'service',
        components:{
        },
        data () {
            return {
                tabPosition:'left',
                pageCurrent:1,
                innerHeight:window.innerHeight,
                activeReport:[],
                activeName:1,
                activityTypes:'activityTrain,trainNotice',
                pageInfo:{
                    pages:2,
                    current:1,
                    total:0,
                    pageSize:10
                },
                getActivityType
            }
        },
        mounted() {
           this.init()
        },
        methods: {
            init(){
                getCopyrightActive({activityTypes:this.activityTypes,pageNo:this.pageInfo.current}).then(res=>{
                    if(res.code==200){
                        this.activeReport = res.result.records;
                        this.pageInfo.pages = res.result.pages;
                        this.pageInfo.current = res.result.current;
                        this.pageInfo.total = res.result.total;
                    }
                })
            },
            handleClick(key){
                if(key == 1){
                    this.activityTypes = 'activityTrain,trainNotice';
                    this.init();
                }else if(key == 2){
                    this.activityTypes = 'activityReport,trainReport';
                    this.init();
                }
                this.activeName = key;
            },
            nextPage(){
                this.pageInfo.current = this.pageInfo.current + 1;
                console.log(this.pageInfo.current);
                this.init();
            },
            prePage(){
                this.pageInfo.current = this.pageInfo.current - 1;
                console.log(this.pageInfo.current);
                this.init();
            },
            activityDetails(item){
                this.$router.push({
                    name: 'activityDetails',
                    params:{
                        id: item.id,
                        type: this.activeName
                    }
                });
                // this.$router.push({
                //     name:'activeDetail',
                //     params:{
                //         id:item.id,
                //         type:type
                //     }
                // })
            }
        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style lang="less" scoped>

.main-activity{
    // background-color: #e4e4e4;
    // box-sizing: border-box;
    // padding: 0.54rem 0.74rem;
    // background-image: url('../../assets/images/active-bg.png');
    // background-repeat: no-repeat;
    // background-size: 100% 100%;
    margin-top: 68px;
    text-align: left;
    
    .activity-content{
        width: 1200px;
        margin: 0 auto;

        .activity-menus{
            height: 50px;
            font-size: 22px;
            border-bottom: 2px solid #EFEFEF;
            padding-top: 50px;
            ul{
                display: flex;
                justify-content: center;
                user-select: none;
            }
            ul li{
                padding: 0 30px;
                color: #999;
                position: relative;
                cursor: pointer;
                height: 50px;
            }
            ul li.active{
                color: #333 !important;
                font-weight: 600;
            }
            ul li.active::after{
                content: "";
                position: absolute;
                left: 0;
                bottom: -1px;
                height: 2px;
                width: 100%;
                background-color: #333;
            }
        }
        .activity-list{
            padding: 60px 0;
            .activity-item{
                display: flex;
                padding: 20px 10px 20px 0;
                cursor: pointer;
                border-bottom: 1px solid #EFEFEF;
                .activity-img{
                    width: 342px;
                    height: 176px;
                    overflow: hidden;
                    img{
                        transition: .5s;
                    }
                }
                .activity-right{
                    flex:1;
                    margin-left: 20px;
                    position: relative;
                    .activity-title{
                        display: flex;
                        color: #666666;
                        justify-content: space-between;
                        .title{
                            font-family: Source Han Sans CN;
                            font-size: 24px;
                            font-weight: 600;
                            line-height: 48px;
                            max-width: 580px;
                            white-space: nowrap; 
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                        .date{
                            font-family: Source Han Sans CN;
                            font-size: 32px;
                            font-weight: 700;
                            line-height: 48px;
                            margin-right: 10px;
                            color: #666666;
                        }
                    }
                    .activity-icon{
                        position: absolute;
                        bottom: 0;
                        right: 50px;
                        padding-left: 30px;
                        font-size: 30px;
                        border-left: 1px solid #EFEFEF;
                        fill: #EFEFEF;
                        height: 32px;
                    }
                     
                    .desc{
                        color: #999;
                    }

                }
                &:hover{
                    .activity-img img{
                        transform: scale(0.9);
                    }
                    background-color: #fff;
                    .title{
                        color: #206BD1;
                    }

                    .desc{
                        color: #999;
                    }
                    .activity-icon{
                        fill: #666;
                        border-left-color: #666;
                    }
                }
            }
        }
    }
}
 
.pagination{
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: center;

}
</style>
<style>
    img{
        max-width:100% ! important;
    }
</style>